var React = require('react');

function IconPaid (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 0C15.522 0 20 4.477 20 10C20 15.522 15.522 20 10 20C4.478 20 0 15.522 0 10C0 4.477 4.478 0 10 0ZM10 2C5.589 2 2 5.589 2 10C2 14.411 5.589 18 10 18C14.411 18 18 14.411 18 10C18 5.589 14.411 2 10 2ZM14.6743 5.88909C15.0707 6.22797 15.1109 6.81666 14.764 7.20396L8.32957 14.3403C7.94635 14.7683 7.2636 14.7639 6.88611 14.3311L5.22785 12.301C4.88623 11.9094 4.93423 11.3212 5.33507 10.9874C5.73591 10.6536 6.3378 10.7005 6.67942 11.0922L7.6214 12.301L13.3287 5.97674C13.6755 5.58945 14.278 5.5502 14.6743 5.88909Z","fill":"#1A8450"}));
}

IconPaid.defaultProps = {"viewBox":"0 0 20 20","fill":"none"};

module.exports = IconPaid;

IconPaid.default = IconPaid;
